<template>
  <div class="index" :class="showUI() ? 'visible' : ''">

    <div class="container">

      <div v-if="productId !== false" class="product">

        <div class="head">

          <div class="row">

            <div class="col-md-3">
              <div class="back" @click.prevent="productId = false; productAmount = 1; productOptions = {}; showAttributes = false;">
                <button>
                  <i class="fa fa-fw fa-angle-left" />
                </button>
                <span>{{ $t("ui.index.catalog.back") }}</span>
              </div>
            </div>

          </div>

        </div>

        <div class="details">

          <div class="info">

            <img :src="getProductItem(productId).thumb" />
            <p>
              <strong>
                {{ getProductItem(productId).name }}
              </strong>
              {{ getProductItem(productId).description }}
              <i>{{ getProductItem(productId).price.substring(1) }}</i>
            </p>

            <ul v-if="getProductItem(productId).related.length > 0">
              <li v-for="relation in getProductItem(productId).related">
                <strong>{{ relation.name }}</strong> {{ relation.price }}
              </li>
            </ul>

            <div class="actions">
              <button @click.prevent="showPersonlize = !showPersonlize" v-if="hasPersonalization(productId)">Personaliseren</button>
              <button v-if="getProductItem(productId).attributes !== false" @click="showAttributes = !showAttributes">
                <i class="fa fa-fw fa-info" />
              </button>
            </div>

            <div class="attributes" v-if="showAttributes">

              <table>
                <tr class="attribute" v-for="attribute in getProductItem(productId).attributes">
                  <td>
                    <strong>{{ attribute.attribute[0].name }}</strong>
                  </td>
                  <td>
                    <span>{{ attribute.attribute[0].text }}</span>
                  </td>
                </tr>
              </table>

            </div>

          </div>

          <div class="customs" v-if="getProductItem(productId).custom !== false">

            <div
              class="personalisation"
              v-for="custom in getProductItem(productId).custom"
              v-if="custom.name.toLowerCase() === 'personalisation' && hasPersonalization(productId) && showPersonlize"
            >

              <strong>Personalisatie</strong>

              <div
                v-for="option in custom.options"
              >

                <a href="#" @click.prevent="chooseOption(custom.type, custom.id, option.product_option_value_id)">
                  <span class="checkbox" :class="optionSelected(custom.type, custom.id, option.product_option_value_id) ? 'selected' : ''">
                    <i
                      class="fa"
                      :class="optionSelected(custom.type, custom.id, option.product_option_value_id) ? 'fa-check-square' : 'fa-square'"
                    />
                  </span>
                  <strong>
                    {{ option.name }}
                  </strong>
                </a>
              </div>
            </div>

            <div
              class="custom"
              v-for="custom in getProductItem(productId).custom"
              v-if="custom.name.toLowerCase() !== 'personalisation'"
            >
              <strong>
                {{ $t("ui.index.product.choose") }} {{ custom.name }}
                <span class="required" v-if="custom.required == 1">
                  <i class="fa fa-fw fa-asterisk" />
                </span>
              </strong>
              <div
                class="options"
                :class="Object.keys(custom.options).length > 5 ? 'options-scrollable' : ''"
              >
                <div
                  class="option"
                  v-for="option in custom.options"
                  :class="optionSelected(custom.type, custom.id, option.product_option_value_id) ? 'selected' : ''"
                >
                  <a href="#" @click.prevent="chooseOption(custom.type, custom.id, option.product_option_value_id)">
                    <strong class="title">{{ option.name }}</strong>
                    <span class="price" v-if="Math.round(option.price) !== 0">
                      {{ (option.replacement != '1' ? option.price_prefix : '') }}
                      {{ parseFloat(option.price).toFixed(2) }}
                    </span>
                  </a>
                </div>
              </div>
            </div>

         </div>

        <div class="add">
            <div>
              <div class="amount">
                  <button @click.prevent="update('-')" v-if="productAmount > 1">
                    <i class="fa fa-fw fa-minus" />
                  </button>
                  <button v-else disabled>
                    <i class="fa fa-fw fa-minus" />
                  </button>
                  <p>{{ productAmount }}</p>
                  <button @click.prevent="update('+')" v-if="productAmount < getProductItem(productId).quantity">
                    <i class="fa fa-fw fa-plus" />
                  </button>
                  <button v-else disabled>
                    <i class="fa fa-fw fa-plus" />
                  </button>
              </div>
            </div>
            <div>
              <button
                v-if="productAmount < getProductItem(productId).quantity"
                @click.prevent="chooseProduct()"
                class="add-cart"
              >
                {{ $t("ui.index.product.add") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="catalog">

        <div class="head">

          <div class="row">

            <div class="col-md-12">
              <h1 v-html="activeCategoryName"></h1>
            </div>

          </div>

        </div>

        <div class="categories">

          <ul>
            <li
              v-for="(category, category_index) in getCategories"
              :key="category_index"
              class="category"
              :class="activeCategory === category.category_id ? 'selected' : ''"
            >
              <a href="#" @click.prevent="selectCategory(category_index, category.category_id)">
                <div class="image">
                  <img :src="category.image" />
                </div>
                <span v-html="category.name"></span>
              </a>
            </li>
          </ul>

        </div>

        <div class="products">

          <div class="subcategories">
            <ul>
              <li
                v-if="activeSubCategory"
                class="subcategory"
                style="width: 58px; margin-right: 15px; opacity: 1;"
              >
                <a href="#" @click.prevent="activeSubCategory = false">
                  <span>
                    <i class="fa fa-fw fa-times" />
                  </span>
                </a>
              </li>
              <li
                v-for="(sub_category, sub_category_index) in getSubCategories"
                v-if="activeCategory === sub_category.parent_id"
                class="subcategory"
                :class="activeSubCategory === sub_category.category_id ? 'selected' : ''"
                :key="sub_category_index"
              >
                <a href="#" @click.prevent="selectSubCategory(sub_category.category_id)">
                  <span v-html="sub_category.name"></span>
                </a>
              </li>
            </ul>
          </div>

          <div class="product-wrapper">

            <div
              v-for="(product, product_index) in getProducts"
              v-if="showProduct(product)"
              :key="product_index"
              class="product"
            >

              <div class="product-unavailable" v-if="product.quantity === 0">
                <span>
                  {{ $t("ui.index.product.soldout") }}
                </span>
              </div>

              <a href="#" @click.prevent="productId = product.product_id">
                <span class="price">{{ product.price.substring(1) }}</span>
                <img :src="product.thumb" />
                <p>{{ product.name }}</p>
              </a>

            </div>

          </div>

        </div>

      </div>

    </div>

    <cart />

  </div>
</template>

<style lang="scss">

  .index {

    opacity: 0;

    &.visible {

      animation-name: fadeIn;
      animation-iteration-count: 1;
      animation-timing-function: ease-in;
      animation-duration: 0.5s;
      opacity: 1;

    }

    .head {

      margin: 60px 0 25px;
      height: 60px;

      h1 {

        font-size: 32px;
        font-weight: 600;
        line-height: 60px;
        margin: 0;

      }

      .back {

        display: inline-block;
        cursor: pointer;

        button {

          background: var(--color-primary);
          display: inline-block;
          color: var(--color-light);
          padding: 0;
          font-size: 36px;
          width: 58px;
          line-height: 55px;
          border-bottom: 5px solid rgba(0, 0, 0, 0.15);

        }

        span {

          display: inline;
          font-size: 24px;
          text-transform: uppercase;
          font-weight: 600;
          margin-left: 20px;

        }

      }

    }

    .catalog {

      .categories {

        position: relative;
        width: calc(100% + 20px);
        height: 160px;
        padding: 5px 0;
        margin-left: -10px;
        overflow-x: scroll;
        overflow-y: hidden;

        ul {

          list-style: none;
          display: inline-block;
          width: max-content;
          padding: 0;
          animation-name: scrollIn;
          animation-iteration-count: 1;
          animation-timing-function: ease-in;
          animation-duration: 1s;
          animation-delay: 1s;

          .category {

            position: relative;
            background: var(--color-light);
            border-radius: 10px;
            float: left;
            width: 200px;
            height: 125px;
            margin: 0 10px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);

            &.selected {

              transform: scale(1.05);
              transition-property: all;
              transition-property: transform;
              transition-duration: 0.25s;
              transition-delay: 1.5s;

              &:after {

                position: absolute;
                content: ' ';
                bottom: -30px;
                left: calc(50% - 15px);
                width: 0;
                height: 0;
                border-left: 15px solid transparent;
                border-right: 15px solid transparent;
                border-bottom: 15px solid #fff;
                z-index: 0;

              }

            }

            a {

              text-decoration: none;
              text-align: center;
              display: block;
              height: 100%;

              .image {

                height: 75px;

                img {

                  display: block;
                  max-width: 80%;
                  max-height: 65px;
                  margin: 10px auto 0;
                  animation-name: fadeIn;
                  animation-iteration-count: 1;
                  animation-timing-function: ease-in;
                  animation-duration: 0.25s;

                }

              }

              span {

                display: block;
                color: #212428;
                font-weight: 500;
                font-size: 15px;
                text-transform: uppercase;

              }

            }

          }

        }

      }

      .subcategories {

        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;

        ul {

          list-style: none;
          display: inline-block;
          width: max-content;
          padding: 0;

          .subcategory {

            position: relative;
            background: var(--color-primary);
            border-radius: 10px;
            float: left;
            opacity: 0.75;
            width: 200px;
            height: auto;
            margin: 30px 10px 20px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);

            &.selected {

              opacity: 1;
              transform: scale(1.05);
              transition-property: all;
              transition-property: transform;
              transition-duration: 0.25s;

            }

            a {

              text-decoration: none;
              text-align: center;
              text-transform: uppercase;
              display: block;
              padding: 15px 5px;
              height: 100%;
              color: #fff;
              font-weight: 600;

            }

          }

        }

      }

      .products {

        position: relative;
        background: var(--color-light);
        padding: 0 25px 100px;
        height: calc(100vh - 750px);
        overflow-y: scroll;
        border-radius: 10px 10px 0 0;

        .product-wrapper {

          display: flex;
          flex-wrap: wrap;

        }

        .product {

          position: relative;
          padding: 10px;
          flex-grow: initial;
          width: calc(33.3% - 25px);
          height: max-content;
          margin: 25px 12.5px;
          animation-name: fadeIn;
          animation-iteration-count: 1;
          animation-timing-function: ease-in;
          animation-duration: 0.25s;
          overflow: hidden;

          &:hover,
          &:focus {

            transform: scale(1.05);
            transition-property: all;
            transition-property: transform;
            transition-duration: 0.25s;

          }

          .product-unavailable {

            position: absolute;
            background: rgba(255, 255, 255, 0.75);
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;

            span {

              position: absolute;
              background: #fff;
              top: 50%;
              left: 50%;
              width: 100%;
              color: red;
              text-align: center;
              font-size: 18px;
              font-weight: 500;
              padding: 10px 0;
              transform: translate(-50%, -50%);

            }

          }

          a {

            text-decoration: none;

          }

          img {

            margin: 0 auto;
            display: block;
            width: auto;
            max-width: 80%;
            height: 175px;

          }

          .price {

            position: absolute;
            bottom: 0;
            width: 100%;
            text-align: center;
            color: var(--color-primary);
            font-weight: 600;

          }

          p {

            display: block;
            color: #212428;
            font-weight: 500;
            font-size: 18px;
            text-transform: uppercase;
            text-align: center;
            margin: 0 0 25px;

          }

        }

      }

    }

    .product {

      position: relative;

      .details {

        position: relative;
        background: var(--color-light);
        padding: 25px 25px 100px;
        margin-top: 40px;
        height: calc(100vh - 610px);
        overflow-y: scroll;
        border-radius: 10px 10px 0 0;

        .info {

          position: relative;
          width: 100%;
          margin-bottom: 25px;
          padding-right: 400px;
          display: inline-block;

          img {

            display: inline-block;
            width: 200px;
            vertical-align: top;

          }

          p {

            display: inline-block;
            width: calc(100% - 200px);
            padding: 10px 25px 10px 45px;

            strong {

              display: block;
              font-size: 18px;
              margin-bottom: 10px;

            }

            i {

              display: block;
              margin-top: 15px;
              color: rgba(0, 0, 0, 0.65);
              font-size: 24px;

            }

          }

          .actions {

            position: absolute;
            top: 0;
            right: 0;
            width: 375px;
            text-align: right;

            button {

              font-size: 20px;
              display: inline-block;
              width: auto;
              padding: 0 25px;
              margin-left: 15px;

            }

          }

          .attributes {

            position: absolute;
            background: var(--color-primary);
            top: 100px;
            right: 0;
            width: 500px;
            padding: 15px 25px;
            border-radius: 10px;

            &:before {

              position: absolute;
              content: ' ';
              top: -15px;
              right: 20px;
              width: 0;
              height: 0;
              border-left: 15px solid transparent;
              border-right: 15px solid transparent;
              border-bottom: 15px solid var(--color-primary);

            }

            table {

              width: 100%;
              text-align: left;
              color: #fff;
              display: table-cell;

              .attribute {

                strong {

                  display: block;
                  margin-right: 15px;

                }

                span {

                  opacity: 0.8;

                }

              }

            }

          }

        }

        .customs {

          border-top: 1px solid rgba(0, 0, 0, 0.25);
          padding-top: 25px;

          .custom {

            margin-bottom: 35px;

            strong {

              text-transform: uppercase;
              font-size: 22px;

              .required {

                font-size: 12px;
                font-weight: 100;
                color: red;
                vertical-align: super;

              }

            }

            .options {

              margin: 10px -5px;
              display: flex;

              .option {

                position: relative;
                background: var(--color-background);
                flex: 1;
                margin: 5px;
                border-radius: 10px;
                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);

                &.selected {

                  background: var(--color-primary);

                  a {

                    color: var(--color-light);

                    .price {

                      color: rgba(255, 255, 255, 0.65);

                    }

                  }

                }

                a {

                  text-decoration: none;
                  text-align: center;
                  color: #222;
                  display: block;
                  padding: 25px 30px;

                }

                .title {

                  display: block;
                  font-size: 18px;

                }

                .price {

                  display: block;
                  color: rgba(0, 0, 0, 0.65);
                  font-size: 16px;

                }

                .check {

                  position: absolute;

                  i {

                  }

                }

              }

              &.options-scrollable {

                overflow-x: scroll;

                .option {

                  width: auto;
                  flex: none;
                  padding: 0 15px;

                }

              }

            }

          }

          .personalisation {

            background: var(--color-background);
            padding: 30px;
            margin-bottom: 50px;
            border-radius: 10px;

            strong {

              text-transform: uppercase;
              font-size: 28px;
              display: block;
              margin-bottom: 15px;

            }

            a {

              color: #212428;
              text-decoration: none;
              display: block;

              strong {

                text-transform: uppercase;
                font-size: 22px;
                display: inline-block;

              }

            }

            .checkbox {

              font-size: 42px;
              vertical-align: middle;
              color: var(--color-primary);
              margin-right: 15px;
              opacity: 0.5;

              &.selected {

                opacity: 1;

              }

            }

          }

        }

      }

      .amount {

        text-align: center;
        margin-bottom: 50px;

        button {

          width: 52px;
          height: 52px;
          line-height: 56px;
          font-size: 28px;

          &:disabled {

            opacity: 0.5;

          }

        }

        p {

          display: inline-block;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          width: 75px;
          text-align: center;
          vertical-align: middle;

        }

      }

      .add {

        padding: 25px;
        width: 100%;

        .add-cart {

          width: 500px;
          margin: 0 auto;
          display: block;

        }

      }

      button {

        background: var(--color-primary);
        display: inline-block;
        color: var(--color-light);
        padding: 0;
        width: 100%;
        line-height: 48px;
        border-bottom: 5px solid rgba(0, 0, 0, 0.15);

      }

    }

  }

</style>

<script>
import Vue from 'vue';
import _ from 'lodash';

import { mapGetters } from "vuex";

import { FETCH_PRODUCTS, FETCH_CATEGORIES, FETCH_OPTIONS, CREATE_CLEARANCE } from "@/store/actions.type";

import { CART_ADD, CART_CLEAR, SET_ALERTS } from '@/store/mutations.type';

import Cart from "@/components/Cart";

export default {
  name: "index",
  components: {
    Cart,
  },
  props: ['product'],
  data() {
    return {
      activeCategory: false,
      activeSubCategory: false,
      activeCategoryName: '',
      showAttributes: false,
      showPersonlize: false,
      productId: false,
      productAmount: 1,
      productOptions: {}
    }
  },
  mounted() {
    this.$store.dispatch(CREATE_CLEARANCE);
    this.$store.dispatch(FETCH_PRODUCTS).then((categories) => {
      if (this.$route.params.id !== undefined) {
        this.productId = this.$route.params.id;
      }
    }).catch(() => {
    });
    this.$store.dispatch(FETCH_CATEGORIES).then((categories) => {
      setTimeout(() => {
        this.activeCategory = categories[0].category_id;
        this.activeCategoryName = categories[0].name;
      }, 750);
    }).catch(() => {
    });
    this.$store.dispatch(FETCH_OPTIONS);
  },
  methods: {
    selectCategory(index, category_id) {
      this.activeCategory = category_id;
      this.activeCategoryName = this.getCategories[index].name;
      this.activeSubCategory = false;
    },
    selectSubCategory(sub_category_id) {
      this.activeSubCategory = sub_category_id;
    },
    chooseProduct() {
      let allow = true;
      let options = this.productOptions;
      let required = _.pickBy(this.getProductItem(this.productId).custom, function(c) { return c.required == 1; });

      Object.keys(required).forEach(function(key) {
        let option = required[key];
        let check = Object.keys(options).includes(option.id.toString());
        if (!check && allow) {
          allow = false;
        }
      });

      if (allow) {
        this.$store.commit(CART_ADD, {
          product: this.productId,
          amount: this.productAmount,
          options: this.productOptions
        });
        this.productId = false;
        this.productAmount = 1;
        this.productOptions = {};
        this.showPersonlize = false;
      }
      else {
        this.$store.commit(SET_ALERTS, {
          type: 'regular',
          title: this.$i18n.t("alerts.items.required_options.title"),
          message: this.$i18n.t("alerts.items.required_options.message")
        });
      }
    },
    chooseOption(type, option, value) {
      let options = this.productOptions[option];
      if (type == 'radio') {
        if (options !== undefined) {
          Vue.delete(this.productOptions, option);
        }
        Vue.set(this.productOptions, option, value);
      }
      else {
        if (_.includes(options, value)) {
          options.splice(options.indexOf(value), 1);
        }
        else {
          if (options !== undefined){
            options.push(value);
          }
          else {
            options = [value];
          }
        }
        Vue.set(this.productOptions, option, options);
      }
    },
    optionSelected(type, option, value) {
      if (type == 'radio') {
        if (this.productOptions[option] === value) {
          return true;
        }
      }
      else {
        if (_.includes(this.productOptions[option], value)) {
          return true;
        }
      }
      return false;
    },
    showProduct(product) {
      if (product.tags !== 'replacement') {
        if (!this.activeSubCategory) {
          return _.includes(
            product.categories,
            parseInt(this.activeCategory)
          );
        }
        else {
          return _.includes(
            product.categories,
            parseInt(this.activeSubCategory)
          );
        }
      }
      return false;
    },
    hasPersonalization(product) {
      let options = this.getProductItem(product).custom;
      let result = false;
      Object.keys(options).forEach(function(key) {
        if (options[key].name.toLowerCase() === 'personalisation') {
          result = true;
        }
      });
      return result;
    },
    showUI() {
      return true;
      if (this.getProducts.length !== 0 && this.getCategories.length !== 0 && this.getOptions.length !== 0) {
        return true;
      }
      return false;
    },
    update(method) {
      if (method === '+') {
        this.productAmount = this.productAmount + 1;
      }
      else {
        this.productAmount = this.productAmount - 1;
      }
    }
  },
  computed: {
    ...mapGetters([
      'getProducts',
      'getCategories',
      'getSubCategories',
      'getOptions',
      'getProductItem'
    ])
  }
};
</script>
